import { useAuth } from "@mindlercare/auth-ui";
import { usePsychologistUser } from "hooks";
import { useSelectedPsychologistIdParam } from "hooks/useSelectedPsychologistParam";
import { useEffect, ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser } from "../hooks/userHooks";
import { clearLocalStorage } from "../helpers/clearLocalStorage";
import { countryIdFromMarket, getCountryCode } from "../helpers/getCountryCode";
import { LoadingView } from "../views/LoadingView";

export const RequiresAuth: React.FC = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { isLoggedIn, logout, marketId, roles } = useAuth();
  const { isLoading: isLoadingPsychologistUser, psychologist } =
    usePsychologistUser({
      skip: !isLoggedIn,
    });
  const { isLoading: isLoadingUser, user } = useCurrentUser();
  const marketSwitchIsAllowed = roles?.some(({ name }) => name === "Admin");
  const [, setSelectedPsychologistId] = useSelectedPsychologistIdParam();

  useEffect(() => {
    if (!isLoggedIn) return;
    if (
      marketId !== countryIdFromMarket(getCountryCode()) &&
      !marketSwitchIsAllowed
    ) {
      logout();
      clearLocalStorage();
    }
  }, [isLoggedIn, marketId, marketSwitchIsAllowed, logout]);

  useEffect(() => {
    if (psychologist?.psychologistId) {
      setSelectedPsychologistId(psychologist.psychologistId);
    }
  }, [isLoadingPsychologistUser, psychologist, setSelectedPsychologistId]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (isLoadingUser || !user) {
    return <LoadingView />;
  }

  return <>{children ?? <Outlet />}</>;
};
